import accessSAdmin from './accessSAdmin'

export default [...accessSAdmin]